(function() { window.GUID_9cedebcf_319a_4b86_9d94_0d6ad32d2f14 = { getGuid: function() { return "9cedebcf-319a-4b86-9d94-0d6ad32d2f14"; } }; })();
var CS;
(function (CS) {
    var CamLight;
    (function (CamLight) {
        var Models;
        (function (Models) {
            var Enums;
            (function (Enums) {
                let PocketEmplacement;
                (function (PocketEmplacement) {
                    PocketEmplacement[PocketEmplacement["TopLeft"] = 0] = "TopLeft";
                    PocketEmplacement[PocketEmplacement["TopRight"] = 1] = "TopRight";
                    PocketEmplacement[PocketEmplacement["SideLeft"] = 2] = "SideLeft";
                    PocketEmplacement[PocketEmplacement["SideRight"] = 3] = "SideRight";
                    PocketEmplacement[PocketEmplacement["BottomLeft"] = 4] = "BottomLeft";
                    PocketEmplacement[PocketEmplacement["BottomRight"] = 5] = "BottomRight";
                    PocketEmplacement[PocketEmplacement["OutsideTheTable"] = 6] = "OutsideTheTable";
                    PocketEmplacement[PocketEmplacement["Unknown"] = 7] = "Unknown";
                    PocketEmplacement[PocketEmplacement["NoPocket"] = -1] = "NoPocket";
                })(PocketEmplacement = Enums.PocketEmplacement || (Enums.PocketEmplacement = {}));
            })(Enums = Models.Enums || (Models.Enums = {}));
        })(Models = CamLight.Models || (CamLight.Models = {}));
    })(CamLight = CS.CamLight || (CS.CamLight = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PocketEmplacement.pre.js.map
